// extracted by mini-css-extract-plugin
var _1 = "SPVsContainerStyle-module__loader-container___lwrsy";
var _2 = "SPVsContainerStyle-module__loader-container___lwrsy";
var _3 = "SPVsContainerStyle-module__shares-container___jfBwl";
var _4 = "SPVsContainerStyle-module__shares-container___jfBwl";
var _5 = "SPVsContainerStyle-module__title___w2VmU";
export { _1 as "loader-container", _2 as "loaderContainer", _3 as "shares-container", _4 as "sharesContainer", _5 as "title" }
